/**
 * Layout-shaped loading skeleton for workspace pages. Pure markup (no hooks) so
 * it works as a Next `loading.tsx` (server component) during navigation AND as
 * the in-workspace mount placeholder, giving one consistent "panels settling in"
 * look instead of a blank flash or a centered spinner.
 */

/** Just the grid of pulsing pane placeholders — no page padding or header. Used
 *  inside PaneWorkspace's own padded grid region (the title is already drawn). */
export function WorkspaceSkeletonGrid({ cards = 6 }: { cards?: number }) {
  return (
    <div
      className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3"
      aria-hidden
    >
      {Array.from({ length: cards }).map((_, i) => (
        <div
          key={i}
          className="h-56 animate-pulse rounded-lg border border-line-soft bg-surface-sunken/40"
        />
      ))}
    </div>
  );
}

/** Full-page skeleton (header bar + grid) for a route-level `loading.tsx`. */
export function WorkspaceSkeleton({ cards = 6 }: { cards?: number }) {
  return (
    <div className="px-4 py-4 xl:px-6 2xl:px-8" aria-hidden>
      <div className="mb-4 h-6 w-40 animate-pulse rounded bg-line-soft" />
      <WorkspaceSkeletonGrid cards={cards} />
    </div>
  );
}
